import {useEffect, useRef} from "react";

export interface IFramePreviewProps {
  code: string,
}

export default function IFramePreview({code}: IFramePreviewProps) {

  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      const doc = iframe.contentDocument || iframe?.contentWindow?.document;

      if (!doc) {
        return;
      }

      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
        <head>
        </head>
        <body>
          ${code}
        </body>
        </html>
      `);
      doc.close();
    }
  }, [code]);

  return (
    <iframe
      ref={iframeRef}
      style={{ border: 'none', width: '100%', height: '60px' }}
      title="Waiver Button"
    />
  );
}